import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {Api} from '@shared/constants/common-field.constants';
import {
    IPlatformToolComponent,
    IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommandResponse} from '@shared/commands/command-base';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';

@Component({
    standalone: false,
    selector: 'app-country-tracker-comparison',
    templateUrl: './country-tracker-comparison.component.html',
    styleUrl: './country-tracker-comparison.component.scss'
})
export class CountryTrackerComparisonComponent implements OnInit, IPlatformToolComponent {

    handler: IPlatformToolHandler;
    invalidateSubject: InvalidateSubject;
    magicLinkModel: MagicLinkModel;
    selectedTab: TabModel;

    countryName: string;
    currentCountryTrackerVersion: string;
    previousCountryTrackerVersion: string;
    countryTrackerCountryCode: string;
    magicLinkId: string;
    documentCategoryContents: any[];
    message = 'Please wait while the system checks for any changes.';

    constructor(private router: Router,
                private platformQueryService: PlatformQueryService,
                private fuseSplashScreenService: FuseSplashScreenService) {
    }

    ngOnInit() {

        const countryTrackerCompareQuery = new PlatformQuery();
        countryTrackerCompareQuery.name = 'CountryTrackerCompareQuery';
        countryTrackerCompareQuery.api = Api.Spreadsheet;

        this.currentCountryTrackerVersion = this.magicLinkModel.fieldValues['CurrentCountryTrackerVersion'];
        this.previousCountryTrackerVersion = this.magicLinkModel.fieldValues['PreviousCountryTrackerVersion'];
        this.countryTrackerCountryCode = this.magicLinkModel.fieldValues['CountryTrackerCountryCode'];
        this.countryName = this.magicLinkModel.fieldValues['CountryTrackerCountryName'];

        countryTrackerCompareQuery.fieldValues['CurrentCountryTrackerVersion'] = this.currentCountryTrackerVersion;
        countryTrackerCompareQuery.fieldValues['PreviousCountryTrackerVersion'] = this.previousCountryTrackerVersion;
        countryTrackerCompareQuery.fieldValues['CountryTrackerCountryCode'] = this.countryTrackerCountryCode;
        this.fuseSplashScreenService.show();
        this.platformQueryService.executeQuery(countryTrackerCompareQuery).subscribe(response => {
            this.documentCategoryContents = response.fieldValues['DocumentCategoryContents'];
            this.message = 'There were no changes detected for this comparison.';
            this.fuseSplashScreenService.hide();
        });
    }

    viewLatestVersion() {
        this.router.navigateByUrl(this.magicLinkModel.fieldValues['PreviousUrl']);
    }

    onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
    }

    onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
    }

    onBeforeExecuteNextCommand(): boolean {
        return false;
    }

    onBeforeExecutePreviousCommand(): boolean {
        return false;
    }


    onLoad() {
    }
}
